import type { Artifact } from "./types";

/** A chart's filter control (VIZ-3), as the server sends it. */
export type Control = NonNullable<Artifact["control"]>;

/** Segments for a handful of values; a slider past that. */
export const SEGMENTS_UP_TO = 6;

/** What a printed chart says instead of the control it cannot have. */
export function printedControl(control: Control): string {
  const others = (control.values ?? []).filter((option) => option !== control.default);
  const listed =
    others.length <= SEGMENTS_UP_TO
      ? others.join(", ")
      : `${others.length} other values (${others[0]} to ${others[others.length - 1]})`;
  return `Showing ${control.label.toLowerCase()} ${control.default}. The interactive version also has ${listed}.`;
}
